<template>
  <div>
    <div class="payment_warp"></div>
    <popup-warp v-model="isPaymentEzPopup" :hideOnBlur="false">
      <div>
        <div class="creditcard-input">
          <div id="paymentEz-element"></div>
        </div>
        <div class="btn creditcard-btn" @click="onPaymentEzSetup">
          {{ i18nPayment.add_payment }}
        </div>
      </div>
    </popup-warp>
  </div>
</template>

<script>
import { mapState } from "vuex";

import paymentezMixin from "../../mixins/paymentez";
import { PopupWarp } from "../../components/popup";
export default {
  mixins: [paymentezMixin],
  computed: {
    ...mapState(["system"]),
    i18nPayment() {
      return this.$t("payment");
    }
  },
  components: {
    PopupWarp
  },
  data() {
    return {
      query: {},
      reference: "",
      live: "",
      isClosed: false,
      isPaymentEzPopup: false
    };
  },
  methods: {
    // 加载PaymentEz支付
    appLoadPaymentEz(query = {}) {
      let paymentInfo = {};
      if (query && query.paymentInfo) {
        paymentInfo = JSON.parse(query.paymentInfo);
      }
      this.appPaymentEz(paymentInfo, response => {
        console.log("appPaymentEz ~ response:", response);
        this.openRouter(`/result?status=success&token=${response.card.token}`);
      });
    },
    loadPay() {
      let _this = this;
      _this.loadPaymentEzScript(() => {
        // eslint-disable-next-line new-cap
        _this.paymentEzCheckout = new PaymentCheckout.modal({
          env_mode: _this.live, // `prod`, `stg`, `local` to change environment. Default is `stg`
          onOpen: function() {
            console.log("modal open");
          },
          onClose: function() {
            console.log("modal closed");
            if (!_this.isClosed) {
              _this.openRouter(`/result?status=closed`);
            }
          },
          onResponse: function(response) {
            console.log("modal response", response);
            _this.isClosed = true;
            if (response.error && response.error.description) {
              _this.openRouter(
                `/result?status=error&message=${response.error.description}`
              );
            } else if (
              response.transaction &&
              response.transaction.status === "success"
            ) {
              _this.openRouter(`/result?status=success`);
            } else {
              _this.openRouter(`/result?status=error&message=payment failed`);
            }
          }
        });

        _this.paymentEzCheckout.open({
          reference: _this.reference
        });
      });
    },
    openRouter(path) {
      if (this.system === "android") {
        window.open(`${process.env.VUE_APP_DOMAIN}/#${path}`);
      } else {
        window.location.href = `${process.env.VUE_APP_DOMAIN}/#${path}`;
      }
    }
  },
  created() {
    console.log("result route:", this.$route.query);
    let { reference, live } = this.$route.query;
    this.reference = reference;
    this.live = live;
    // this.loadPay();
    this.query = this.$route.query;
    this.appLoadPaymentEz(this.query);
  }
};
</script>
<style scoped lang="less">
.payment_warp {
  min-height: 62vh;
  overflow-y: scroll;
  margin: 42px 32px 0;

  .confirm-btns {
    padding: 60px;
  }
  + .popup {
    .creditcard-input {
      margin: 48px 48px 80px;
      padding: 20px;
      border-radius: 20px;
      border: 1px solid #e4e7ed;
    }

    .creditcard-btn {
      margin: 48px;
      color: #fff;
      background: #000;
    }
  }
}
</style>
